import React from 'react'
import Box from '@mui/material/Box'
import { reExportedColors } from '../../1elements'

const TableBodyRow = ({ isOpen, children, className }) => {
  return (
    <Box
      className={className}
      sx={{
        background: reExportedColors.TABLE_ROW,
        display: isOpen ? 'grid' : 'none',
        gridColumnStart: 'span 12',
        gridTemplateColumns: 'repeat(12, 1fr)',
        height: '40px',
        '&:hover': {
          background: reExportedColors.LIGHT_GREY,
          borderRadius: '4px'
        }
      }}
    >
      {children}
    </Box>
  )
}

export default TableBodyRow
